import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { VALID_COLOR } from '../../lib/StyledComponents/Theme/common';

export interface ITableContain {
  tablePadding?: string;
}

export const TableContain = Styled.table<ITableContain>`
  width: 100%;
  padding: ${props => props.tablePadding};
  table-layout: fixed;
`;

TableContain.defaultProps = {
  tablePadding: '0',
};

export const TBody = Styled.tbody`
  width: 100%;
`;

export interface ICell {
  cellPadding?: string;
  fontWeight?: string;
  displayColor?: VALID_COLOR;
  iconColor?: VALID_COLOR;
  th?: string;
}

const DEFAULT_CELL_COLOR: VALID_COLOR = 'default';

// tslint:disable no-non-null-assertion
export const Cell = Styled.td<ICell>`
  padding: ${({ cellPadding }) => cellPadding};
  vertical-align: middle;
  white-space: pre-line;
  color: ${({ theme: { table }, displayColor }) => table[displayColor || DEFAULT_CELL_COLOR].colorText};
  font-weight: ${({ fontWeight }) => fontWeight};

  svg {
    fill: ${({ theme: { table }, displayColor }) => table[displayColor || DEFAULT_CELL_COLOR].colorIcon};
    width: 19px;
    height: 19px;
    vertical-align: baseline;
    display: inline-block;
    padding-right: 0.25em;
  }

  ${props => props.th && `
    display: block;

    &:before {
      width: 50%;
      display: inline-block;
      content: '${props.th}';
      font-weight: 700;
      text-transform: capitalize;
      color: ${props.theme.text.colorText};
    }
  `}

  ${media.small`
    display: table-cell;

    &:before {
      display: none;
    }
  `}
`;
// tslint:enable

Cell.defaultProps = {
  cellPadding: '1em',
  iconColor: 'default',
  displayColor: 'default',
  fontWeight: 'normal'
};

export interface IHeaderCell extends ICell {
  collapse?: boolean;
}

export const HeaderCell = Styled.th<IHeaderCell>`
  padding: ${({ cellPadding }) => cellPadding};
  vertical-align: middle;
  white-space: pre-line;
  font-size: ${({ theme: { label } }) => label.size};
  font-weight: ${({ theme: { table: { header } } }) => header.fontWeight};
  text-transform: capitalize;

  ${props => props.collapse && `
    display: none;
  `}

  ${media.small`
    display: table-cell;
  `}
`;

export const HeaderCellSubheading = Styled(HeaderCell)`
  font-weight: ${({ theme: { table: { header } } }) => header.fontWeight};
`;

HeaderCell.defaultProps = {
  cellPadding: '0.5em 1em'
};

export interface IRow {
  borderColor?: string;
}

export const Row = Styled.tr<IRow>`
  border-bottom: 1px solid ${props => props.borderColor || props.theme.colorSlate10};

  &:last-child {
    border-bottom: none;
  }
`;

export const RowBorderOnlySmall = Styled(Row)`
  ${media.small`
    border-bottom: none;
  `}
`;
